/**
 * Where minted short links point, per environment.
 *
 * Mirrors the split in `apps/bl/src/api/cors-origins.ts`. BL mounts the
 * redirect at the root (`/l`), alongside `/health` and `/cron`, and is
 * same-origin with the front end wherever `NEXT_PUBLIC_BACKEND_URL` is blank —
 * so the public origin and the redirect origin are the same string.
 *
 * DEVELOPMENT IS THE PUBLIC DEV ORIGIN, NOT `localhost:8080` (2026-08-11).
 * A minted link is a PUBLISHED string: quoted into deliverables, pasted into
 * messages, used as an `<img src>`, and — the case that broke — handed back to
 * our own `page_read`. A loopback origin is none of those things anywhere but
 * on the box that minted it, and `page_read`'s SSRF preflight refuses loopback
 * outright, so in dev every research link was guaranteed unreadable by the one
 * tool that reads links (11 rejections in the 2026-08-11 live run). The dev
 * edge already routes `/l/*` to BL at this origin — the same route `/api/*`
 * uses — so the published string is now reachable from anywhere the front end
 * is. (`page_read` also unwraps our own short links before the gate, so the two
 * fixes are independent: this one makes the link real for HUMANS and for
 * anything outside BL's own process.)
 */
export enum ShortLinkOrigin {
  Production = 'https://cabal-ai.io',
  Development = 'https://cabal.smalltree.cloud',
}
